import axios from "axios";
import api from "./axiosInstance";
import { createHeaders, createAuthHeaders } from "./Constant";
 
const hostname = window.location.hostname;
const isLocal = hostname === "localhost" || hostname === "127.0.0.1";

const baseMap = {
  "customer-vkyc.finhub.habilelabs.io": "https://endpoint-gateway.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // prod
  "endpoint-gateway-test.finhub.habilelabs.io": "https://endpoint-gateway-test.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc", // test 
  "customer-vkyc-stage.finhub.habilelabs.io": "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc",  // stage
};

const baseURL = isLocal
  ? "http://localhost:8000/api/v1/vkyc"
  : baseMap[hostname] || "https://endpoint-gateway-stage.finhub.habilelabs.io/vkyc-backend/api/v1/vkyc";
 
console.log('KYCUserService - Base URL:', baseURL);
console.log('KYCUserService - Hostname:', hostname);
console.log('KYCUserService - Is Local:', isLocal);
 
export const KycUserService = {
  /**
   * Create a new KYC User in the backend
   * @param {Object} userData - { name, email, mobile }
   */
  async createUser(userData, user) {
    const url = `${baseURL}/create-kyc-applicant`;
    console.log('KYCUserService.createUser - API endpoint:', url);
    console.log('KYCUserService.createUser - Payload:', userData);
 
    try {
      const response = await api.post(url, userData, {
        headers: {
          ...createAuthHeaders(user),
          "Content-Type": "application/json",
        },
      });
 
      console.log('KYCUserService.createUser - API response:', response);
      return response.data;
    } catch (error) {
      console.error("KYCUserService.createUser - Error:", error);
      throw error;
    }
  },
 
  /**
   * Fetch all KYC Users from the backend
   */
  async getUsers(user) {
    const url = `${baseURL}/kyc-applicants`;
    console.log('KYCUserService.getUsers - API endpoint:', url);
 
    try {
      const response = await api.get(url, {
        headers: {
          ...createAuthHeaders(user),
          "Content-Type": "application/json",
        },
      });
 
      console.log('KYCUserService.getUsers - API response:', response);
      return response.data;
    } catch (error) {
      console.error("KYCUserService.getUsers - Error:", error);
      throw error;
    }
  },

  async checkKycStatus(session) {
    const url = `${baseURL}/kyc-applicant-status/${session}`;
    console.log('KYCUserService.getKycStatus- API endpoint:', url);
 
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });
 
      console.log('KYCUserService.getKycStatus - API response:', response);
      return response;
    } catch (error) {
      console.error("KYCUserService.getKycStatus - Error:", error);
      throw error;
    }
  },

    /**
   * Create a new KYC session for the applicant
   * @param {Object} payload - { applicant_id, session_metadata }
   */
    async createSession(payload, customerSession) {
      const url = `${baseURL}/session`;
      console.log("KycUserService.createSession - API endpoint:", url);
      console.log("KycUserService.createSession - Payload:", payload);
  
      try {
        const response = await axios.post(url, payload, {
          headers: {
            "Content-Type": "application/json",
            "session": customerSession,
          },
        });
  
        console.log("KycUserService.createSession - API response:", response.data);
        return response;
      } catch (error) {
        console.error("KycUserService.createSession - Error:", error);
        throw error;
      }
    },

  /**
   * Decrypt encrypted applicant data
   * @param {Object} data - { applicant_id, encrypted_name, encrypted_email, encrypted_phone }
   */
  async decryptApplicantData(data, user) {
    const url = `${baseURL}/decrypt-data`;
    console.log('KycUserService.decryptApplicantData - API endpoint:', url);
    console.log('KycUserService.decryptApplicantData - Payload:', data);

    try {
      const response = await axios.post(url, data, {
        headers: {
          ...createAuthHeaders(user),
          "Content-Type": "application/json",
        },
      });

      console.log('KycUserService.decryptApplicantData - API response:', response.data);
      return response.data;
    } catch (error) {
      console.error("KycUserService.decryptApplicantData - Error:", error);
      throw error;
    }
  },
  
};